import clevertap from "clevertap-web-sdk";
import Stories from "react-insta-stories";

// components
import Modal from "components/LoginAndRegister/Modal";
import StoriesCaption from "./StoriesCaption";

// custom hook
import { useMediaQuery } from "customHooks/useMediaQuery";

// assets
import { SvgClose } from "assets/icons/js/SvgClose";
import { SvgArrowUp } from "assets/icons/js/SvgArrowUp";

// style
import "./style.scss";
import { useEffect } from "react";
import { SvgRightArrow } from "assets/icons/js/SvgRightArrow";

interface PageProps {
	openStories: boolean;
	closeStories: () => void;
	videos?: any;
	setNum?: any;
	total?: any;
	type?: string;
	id?: any;
	seoUrl?: string;
	query?: any;
}

const ListingStories = ({
	openStories,
	closeStories,
	videos,
	setNum,
	total,
	type,
	id,
	seoUrl,
	query,
}: PageProps) => {
	// This will come from API
	const stories: any = [];

	videos?.map((item: any) => {
		// @ts-ignore
		if (item?.caption) {
			return stories.push({
				url: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/c_scale,q_60,w_720/${item.video_url}`,
				// duration: item.duration,
				seeMore: ({ close }: { close: any }) => {
					return <StoriesCaption close={close} caption={item.caption} />;
				},
				seeMoreCollapsed: ({ toggleMore }: { toggleMore: any }) => {
					return (
						<div
							className="listing-stories__see-more-collapsed"
							onClick={toggleMore}
						>
							<span>
								<SvgArrowUp />
							</span>
							<button aria-label="see-more">See More</button>
						</div>
					);
				},
				type: "video",
			});
		} else {
			return stories.push({
				url: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/c_scale,q_60,w_720/${item.video_url}`,
				// duration: item.duration,
				type: "video",
			});
		}
	});

	useEffect(() => {
		let tag = document.getElementsByTagName("video");
		if (tag[0]) {
			tag[0].volume = 0.1;
		}
	}, [openStories]);

	const width = useMediaQuery();

	const isMobile = width < 660 ? true : false;

	return (
		<Modal shouldShow={openStories} onRequestClose={closeStories}>
			<SvgClose
				className="listing-stories__cross"
				onClick={() => closeStories()}
			/>
			<Stories
				stories={stories}
				width={isMobile ? 350 : 432}
				height={isMobile ? 540 : 768}
				isPaused={true}
				keyboardNavigation={true}
				currentIndex={0}
				onAllStoriesEnd={() => {
					closeStories();
				}}
			/>
			<div style={{ position: "relative" }}>
				{type === "search" ? (
					<>
						<span
							className="btn-stories left"
							onClick={() =>
								setNum((prev: number) => (prev > 0 ? prev - 1 : 0))
							}
						>
							<SvgRightArrow style={{ rotate: "180deg" }} />
						</span>
						<span
							className="btn-stories right"
							onClick={() =>
								setNum((prev: number) => (prev < total ? prev + 1 : 0))
							}
						>
							<SvgRightArrow />
						</span>
						<button
							className="stories-view"
							onClick={() => {
								clevertap.event.push("listingstories_search_page", {
									listing_id: id,
									listing_name: seoUrl,
									timestamp: new Date(),
								});
								window.open(
									`/view/${seoUrl + "-"}${id}?adults=${
										query?.get("guests") || ""
									}&children=${query?.get("children") || ""}&infants=${
										query?.get("infants") || ""
									}&rooms=${query?.get("rooms") || ""}
								&checkin=${query?.get("checkin") ? query.get("checkin") : ""}&checkout=${
										query?.get("checkout") ? query.get("checkout") : ""
									}}&utm_source=SEARCH_HIGHLIGHTS`,
									width <= 800 ? "" : "_blank",
								);
							}}
						>
							View Home
						</button>
					</>
				) : null}
			</div>
		</Modal>
	);
};

export default ListingStories;
